import { render, staticRenderFns } from "./PdpaList.vue?vue&type=template&id=5d45ee97&"
import script from "./PdpaList.vue?vue&type=script&lang=js&"
export * from "./PdpaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports